import ReactDOM from 'react-dom';
import {fetch} from 'whatwg-fetch';
import { Toast } from 'antd-mobile';
let oLoad=ReactDOM.findDOMNode(document.getElementById("page-load"));
function request(pUrl,pType='get'.toLocaleLowerCase(),data={}){
    showLoad();
    let config={},headers={}, token='',params='';
    if(pType==='file'.toLocaleLowerCase()){
        pType="post";
        if(data instanceof Object){
            params=new FormData();
            for(let key in data){
                params.append(key,data[key]);
            }
        }
        config={
            method:pType,
            body:params
        }
    }else if (pType ==="get".toLocaleLowerCase()){
        config = {
            method: pType
        }
    }else{
    	let LoginData = localStorage['LoginData'] !== undefined?JSON.parse(localStorage['LoginData']):'';
    	if(LoginData !== ''){
    		token = LoginData.token;
    	}
        headers = {
            'Content-Type':'application/json; charset=utf-8',		//application/json; charset=utf-8
            'token': token
        }
        config = {
            method: pType,
            headers,
            body:JSON.stringify(data)
        }
    }
    return new Promise((rel, rej)=>{
    	fetch(pUrl,config).then(res=> {
	        hideLoad();
	        res.json().then((response)=>{
	        	if((pUrl.indexOf('Study/S005') >= 0 || pUrl.indexOf('Study/S004') >= 0) && response.code == 1){
	        		Toast.info('获取用户信息失败，请重新注册！',1.5);
	        	}else if(response.message == '手机号未注册'){
	        		Toast.info(response.message,1.5);
	            	setTimeout(function(){
	            		window.location.hash = '#/RegIndex/index';
	            	}, 2000);
	            	return false;
	        	}else if(response.code == 3){
	        		Toast.info(response.message,1.5);
	            	setTimeout(function(){
	            		window.location.hash = '#/againlogin';
	            	}, 2000);
	            	return false;
	        	}else if(response.code == 1 && response.message.indexOf('其他地方登陆') >= 0){
	        		setTimeout(function(){
	            		window.location.hash = '#/againlogin';
	            	}, 2000);
	            	return false;
	        	}else if(response.code == 1 && pUrl.indexOf('Study/S018') >= 0){
	        		return rel(response)
	        	}
				// else if(response.code == 1){
	   //      		Toast.info(response.message,1.5);
	   //          	return false;
	   //      	}
				else{
	        		return rel(response)
	        	}
		　　  })
	    });
    })
}
function request2(pUrl,pType='get'.toLocaleLowerCase(),data={}){
    let config={},headers={}, token='',params='';
    if(pType==='file'.toLocaleLowerCase()){
        pType="post";
        if(data instanceof Object){
            params=new FormData();
            for(let key in data){
                params.append(key,data[key]);
            }
        }
        config={
            method:pType,
            body:params
        }
    }else if (pType ==="get".toLocaleLowerCase()){
        config = {
            method: pType
        }
    }else{
    	let LoginData = localStorage['LoginData'] !== undefined?JSON.parse(localStorage['LoginData']):'';
    	if(LoginData !== ''){
    		token = LoginData.token;
    	}
        headers = {
            'Content-Type':'application/json; charset=utf-8',		//application/json; charset=utf-8
            'token': token
        }
        config = {
            method: pType,
            headers,
            body:JSON.stringify(data)
        }
    }
    return new Promise((rel, rej)=>{
    	fetch(pUrl,config).then(res=> {
	        res.json().then((response)=>{
	        	if((pUrl.indexOf('Study/S005') >= 0 || pUrl.indexOf('Study/S004') >= 0) && response.code == 1){
	        		Toast.info('获取用户信息失败，请重新注册！',1.5);
	        	}else if(response.message == '手机号未注册'){
	        		Toast.info(response.message,1.5);
	            	setTimeout(function(){
	            		window.location.hash = '#/RegIndex/index';
	            	}, 2000);
	            	return false;
	        	}else if(response.code == 3){
	        		Toast.info(response.message,1.5);
	            	setTimeout(function(){
	            		window.location.hash = '#/againlogin';
	            	}, 2000);
	            	return false;
	        	}
				// else if(response.code == 1){
	   //      		Toast.info(response.message,1.5);
	   //          	return false;
	   //      	}
				else{
	        		return rel(response)
	        	}
		　　  })
	    });
    })
}
function fnTokenError(data){
	Toast.info(data.message,1.2);
	setTimeout(function(){
		window.location.hash = '/RegIndex/index';
	}, 1500);
}
function showLoad(){
	//console.log(1)
    oLoad.style.display="block";
}
function hideLoad(){
	//console.log(2)
    oLoad.style.display="none";
}
export {
    request,
    request2,
    fnTokenError
};